// extracted by mini-css-extract-plugin
export default {"info":"AdressForm_info__1QoGu"};